import * as Sentry from '@sentry/react';
import Context from './context';

export const initializeSentry = () => {
  Sentry.init({
    dsn: 'https://69389702f6f8427cdf73dc61eb13ac21@o1401854.ingest.us.sentry.io/4510403677650945',
    sendDefaultPii: true,
    tunnel: `${Context.APIUrl?.replace('/api', '')}/tunnel`,
    environment: Context.Env,
  });
};